// extracted by mini-css-extract-plugin
export default {"contaner":"contaner__2651129f","heading":"heading__2651129f","subheading":"subheading__2651129f"};